import { useCallback, useRef } from 'react'
import confetti from 'canvas-confetti'

function prefersReducedMotion(): boolean {
  if (typeof window === 'undefined' || !window.matchMedia) return false
  return window.matchMedia('(prefers-reduced-motion: reduce)').matches
}

export function useWorkerBornCelebration() {
  const firedRef = useRef(false)

  const celebrate = useCallback(() => {
    if (firedRef.current) return
    firedRef.current = true

    if (prefersReducedMotion()) return

    confetti({
      particleCount: 60,
      spread: 90,
      origin: { y: 0.65 },
      colors: ['#8b5cf6', '#d946ef', '#ec4899', '#a78bfa'],
      scalar: 0.9,
      ticks: 200,
    })

    window.setTimeout(() => {
      confetti({
        particleCount: 40,
        spread: 120,
        origin: { y: 0.7, x: 0.3 },
        colors: ['#22c55e', '#eab308', '#8b5cf6'],
        scalar: 0.8,
      })
      confetti({
        particleCount: 40,
        spread: 120,
        origin: { y: 0.7, x: 0.7 },
        colors: ['#22c55e', '#eab308', '#ec4899'],
        scalar: 0.8,
      })
    }, 280)
  }, [])

  const reset = useCallback(() => {
    firedRef.current = false
  }, [])

  return { celebrate, reset }
}
